if (!customElements.get("c-gift-card")) {
  customElements.define(
    "c-gift-card",
    class GiftCard extends HTMLElement {
      giftCardBuilder = null;
      constructor() {
        super();

        this.addEventListener("click", () => this.handleClick);

        let giftCardConfigure = document.querySelector(".sc-builder ");
        const timeLoop = setInterval(() => {
          if (giftCardConfigure !== null) {
            clearInterval(timeLoop);
            this.handleLoad(giftCardConfigure);
          } else {
            giftCardConfigure = document.querySelector(".sc-builder");
          }
        }, 1000);

        setTimeout(() => {
          if (!giftCardConfigure) clearInterval(timeLoop);
        }, 20000);
      }

      handleLoad = () => {
        const giftCardBuilder = this.querySelector(".sc-builder");
        this.giftCardBuilder = giftCardBuilder;
        const typesButtons = giftCardBuilder.querySelector(".sc-card-type");
        const inputTo = giftCardBuilder.querySelector("#sc-builder__to");
        const inputFrom = giftCardBuilder.querySelector("#sc-builder__name");
        const inputEmail = giftCardBuilder.querySelector("#sc-builder__email");
        // const selectTitle = giftCardBuilder.querySelector(
        //   ".sc-card-options > h4"
        // );
        // selectTitle.innerText = "Select Amount";
        this.handleInsertAdditionalElement(giftCardBuilder);
        inputEmail.setAttribute("placeholder", "Recipient email address");

        const inputMessage = giftCardBuilder.querySelector(
          "#sc-builder__message"
        );
        inputMessage.style.height = "30px !important";
        inputMessage.setAttribute("placeholder", "Message");
        typesButtons?.addEventListener("click", (e) => {
          this.handleTypeSelect(e);
        });

        inputTo.setAttribute("placeholder", "To");
        inputFrom.setAttribute("placeholder", "From");
      };

      handleTypeSelect = (event) => {
        if (event.target.closest(".sc-card-tab")) {
          this.giftCardBuilder.children[0].innerText =
            event.target.closest(".sc-card-tab").children[0].innerText;
        }
      };
      handleInsertAdditionalElement = (container) => {
        const newElement = document.createElement("div");
        newElement.innerHTML = `<p>Your Olivia & Pearl E-Gift Card will be emailed directly to your recipient, along with a personal message from you.</br>For full terms and conditions, please click <a href="/pages/terms-conditions" style="text-decoration: underline;">here</a>.</p>`;
        const titleElement = container.querySelector("h1");
        titleElement.parentNode.insertBefore(
          newElement,
          titleElement.nextSibling
        );
      };
    }
  );
}
